<template>
  <GenericProgressLinear :icon="'mdi-book'" :title="'Tomes'" :stats="stats"></GenericProgressLinear>
</template>


<script>
import { mapGetters } from "vuex"
import GenericProgressLinear from "./GenericProgressLinear"

export default {
  name: "TomesProgressLinear",
  components: { GenericProgressLinear },
  computed: {
    ...mapGetters("entities/tomes",["stats"])
  },
};
</script>
